import { Link } from "../components/link"
import { SiteHeader } from "../components/site-header"

export function NotFoundPage() {
  return (
    <div className="site-frame">
      <SiteHeader />
      <main className="simple-page">
        <div className="eyebrow">404</div>
        <h1>Page unavailable.</h1>
        <p>Head back to the main site to continue.</p>
        <Link href="/" className="button">
          Back home
        </Link>
      </main>
    </div>
  )
}
